exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pages{background:#faf8fa;height:98%;padding:20px 12px 0}.cont{background:#fff;border-radius:10px;padding:30px 15px 26px}.title_text{letter-spacing:1px;font-size:15px;padding:0 10px}.money,.title_text{text-align:center;font-weight:600;color:#3a383b}.money{font-size:30px;margin:20px 0}.btnPay{background:#60c676;border-radius:4px;text-align:center;width:50%;margin:0 auto;height:28px;font-weight:500;letter-spacing:1px;font-size:14px;line-height:28px;color:#fff;padding:6px 20px}.text_bottom{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;margin:30px 0}.text_bottom:nth-child(4){margin-bottom:0}.font_text{color:#3a383b;font-size:14px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4a06db78","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Pay/toPay.vue
// module id = oQ89
// module chunks = 1